import * as _ from 'lodash';
import { EditableAttribute } from '../attributes/editableAttribute';
import { ApplicationQuestion } from '../application-definition/application-question';

export class FormPage {
  public name: string;
  public description: string;
  public pageNumber: number;
  public id: string;
  public formId: string;
  public questions: ApplicationQuestion[] = [];

  public static parse(data: any): FormPage {
    if (!data) return null;

    let formPage = new FormPage();
    Object.assign(formPage, data);

    return formPage;
  }

  public moveQuestion(oldIndex: number, newIndex: number) {
    let movedValue = this.questions.splice(oldIndex, 1);
    this.questions.splice(newIndex, 0, ...movedValue);
  }
}

export class ApplicationFormPage {
  public name: string;
  public description: string;
  public pageNumber: number;
  public id: string;
  public formId: string;
  public editableAttributes: EditableAttribute[] = [];

  public static parse(data: any): ApplicationFormPage {
    if (!data) return null;

    let applicationFormPage = new ApplicationFormPage();
    Object.assign(applicationFormPage, data);

    return applicationFormPage;
  }

  get hasAttributes(): boolean {
    return this.editableAttributes && this.editableAttributes.length > 0;
  }
  get requiresValidation(): boolean {
    if (!this.hasAttributes) return false;
    let hasRequired = _.some(this.editableAttributes, (attribute) => attribute.required);
    let hasRanges = _.some(this.editableAttributes, (attribute) => attribute.needsRangeCheck);
    let hasDateRange = _.some(
      this.editableAttributes,
      (attribute) => attribute.needsDateRangeCheck
    );
    let hasDate = _.some(this.editableAttributes, (attribute) => attribute.needsDateCheck);
    return hasRequired || hasRanges || hasDateRange || hasDate;
  }

  get isValid(): boolean {
    if (!this.hasAttributes) {
      return true;
    }

    if (!this.requiresValidation) {
      return true;
    }

    return _.chain(this.editableAttributes)
      .every((attribute) => attribute.isValid)
      .value();
  }
}
